module.exports = __webpack_public_path__ + "media/video.a2ea7851.mp4";